import type { SVGProps } from 'react';
const SvgTextRotationAngleup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotation_angleup_svg__a)">
      <path
        fill="currentColor"
        d="M4.49 4.21 3.43 5.27 7.85 16.4l1.48-1.48-.92-2.19 3.54-3.54 2.19.92 1.48-1.48L4.49 4.21Zm3.09 6.8L5.36 6.14l4.87 2.23-2.65 2.64Zm12.99-1.68h-4.24l1.41 1.41-8.84 8.84L10.32 21l8.84-8.84 1.41 1.41V9.33Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotation_angleup_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotationAngleup;
